import type { IBrandConfig } from './types';

const FINANCIAL_SHIELDCIAL_SHIELD_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.pango.co/privacy-policy',
  },
  termsOfService: { kind: 'cms', path: 'policy/tou/financial-shield-terms.md' },
  /* Angular's sidebar-nav-link intercepts this brand's website-terms click and leaves
     for pango.co rather than rendering the document in-app. */
  websiteTermsOfUse: {
    kind: 'external',
    url: 'https://www.pango.co/website-terms-of-use/',
  },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'CyEx, LLC',
  carouselBanners: true,
  showTheftText: false,
  licensor: 'cyex',
  adaChat: true,
  accountDetails: true,
  vaultProject: 'financial_shield',
  hasCustomerServiceSupport: true,
  headerPhone: true,
  security: true,
  missingPII: true,
  finishSetup: true,
  secureUpload: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default FINANCIAL_SHIELDCIAL_SHIELD_BRAND_CONFIG;
